import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const GenerateClientInvoiceReport = (apiData) => async (dispatch) => {
  try {
    const response = await axios({
      method: "get", // Change GET to POST
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
      },
      url: `${actionType.environment_url}/api/admin/client/GenerateClientInvoiceReport`,
      params: {
        ...apiData,
        client_org_ids: JSON.stringify(
          apiData.client_org_ids?.map((item) => item?.organisation_id)
        ),
      
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};
